import { render } from "./ProfileMenu.vue?vue&type=template&id=31fc9399&scoped=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"

import "./ProfileMenu.vue?vue&type=style&index=0&id=31fc9399&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fc9399"]])

export default __exports__